module.exports = __webpack_public_path__ + "img/post2.ce8654e0.png";